import React from 'react';
import { connect } from 'react-redux';
import ProductGrid from '../../common/ListingPage/ProductGridDesktop';
import NoSearchResult from '../../common/NoSearchResult';
import ProductListContainer from '../../common/ListingPage/ProductListingContainer';
import FacetFilterDesktopLeftPane from '../../common/ListingPage/FacetFilterDesktopLeftPane';
import Layout from '../Layout';
import NotFound from '../../common/NotFound';
import Error503 from '../../common/Error503';
import FacetCheckboxModalContentDesktop from '../../common/ListingPage/FacetCheckboxModalContentDesktop';
import FacetCategoryCheckboxModalContentDesktop from '../../common/ListingPage/FacetCategoryCheckboxModalContentDesktop';
import TopFiltersDesktop from '../../common/ListingPage/TopFiltersDesktop';
import AppliedFilter from '../../common/ListingPage/AppliedFilter';
import BreadCrumb from '../../common/BreadCrumb';
import ProductQuickview from '../../common/ListingPage/quickview/ProductQuickview';
import Loader from '../../common/Loader';
import Info from '../../common/ListingPage/InfoDesktop';


import OfferInfoCartData from '../../common/OfferInfoCartData';
import { DealOfTheDayTimerTag } from '../../common/DodCommonComponent/DodCommonComponent';
import { IsDealStart, IsDealEnd } from '../../common/DodCommonComponent/DodComponentFunctionality';
import { DealOfTheDayModal } from '../../common/DodCommonComponent/DodModals';
import Modal from '../../common/Modal';
import { showModal, hideModal } from '../../../actions/modal';
import TimerStartBeforeComponent from '../../common/TimerStartBeforeComponent';
import screen from '../../../refresh/constants/pageType.constant';
import { getPageInfo } from '../../../utils/pageInfo';
import {isCopilotReferrer} from '../../../utils/common'
import {
  getPriceRevealSaleDuration,
  getBBSWidgetTitleForGA
} from '../../common/PriceRevealPLPBanner/priceRevealUtil';
import {
  gtmPagePush,
  gtmEventPush,
  gtmDynamicRemarketingSetup,
  getPLPTypeOfRedirection
} from '../../../modules/ga/GTMdatalayer';

import {
  getLuxeFlags,
  getClusterFeatureFlag,
  getEarlyAccessbannerFlagCategory,
  getEarlyAccessFlag
} from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import luxeScreens from '../../../refresh/constants/luxeScreenType';
import NoResultPage from '../NoResultPage';
import PriceRevealPLPBanner from '../../common/PriceRevealPLPBanner';
import {
  readCookie,
  readClusterCookie,
  updateClusterCookie,
  updatePlpAdsCookie,
  updateSlpAdsCookie,
  checkEarlyAccessUser
} from '../../common/Cookie';
import { signInCheck } from '../../common/CheckUserStatus';
import { getLocaleData } from '../../../actions/localeBannerApi/localeClientCall';
import ErrorMessage from '../../common/ErrorMessage';
import getPlpExtendedBannerImages, {
  getPlpBanners
} from '../../../refresh/selectors/plpExtendedBanner';
import PlpExtendedBanner from '../../../refresh/organism/PlpExtendedBanner';
import { getRuntimeBanners } from '../../../actions/homeData';
import {
  jioAdsShowOnPageLoad,
  fireAddTrackers,
  jioAdsSearchViewEvent,
  jioAdsProductListViewEvent,
  deeplinkLaunchEvent
} from '../../../utils/jioAds';
import { pageUrls } from '../../../constants/banner';
import { getCategoryBannerRequestData } from '../../../utils/banner';
import { DURING_SALE } from '../../../refresh/constants/product.constants';
import EarlyAccessBanner from '../../common/PriceRevealPLPBanner/EarlyAccessBanner';
import { getPreviousSearchSource, getPageCategory } from '../../../refresh/selectors/productpage';
import { getAmplitudeVariantPayload, getAmplitudeExperimentVariant } from '../../../utils/amplitudeCommon';
import { getEnableAdsOnPlp } from '../../../refresh/selectors/featureFlagsSelector';

class Category extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      productsViewCoordinate: {},
      isPriceRevealState: false,
      isJioAdsLoaded: true
    };
    // this.state = {
    //   "fixedBtnProps" : {
    //     popupBtnText : 'Proceed To Shipping',
    //     proceedText: 'Go to bag',
    //     popUpAction : () => {
    //       this.props.hideModal("order-summary-popup")
    //     },
    //     proceedAction : () => {
    //         this.props.proceedShipping((redirectURI) => {
    //             window.location = redirectURI;
    //         });
    //     }
    //   }
    // }
    this.updateFacetStyle = this._updateFacetStyle.bind(this);
    this.facetReference;
    this.lastScrollPosition;
  }

  componentDidMount() {
    const {
      metaData: { name = '', sis = false } = {},
      flags,
      totalResults,
      productsAdditionalInfo = {},
      pathname,
      searchTerm = '',
      clusterFeatureFlag,
      enableAdsOnPlpFlag,
      entities,
      getLocaleData,
      plpExtendedBannerData,
      getBanners,
      earlyAccessCategory,
      newDesignLuxe,
      searchText,
      previousSource,
      pageCategory,
      isVertexCategoryEnabled=false,
    } = this.props;
    const { jioAds } = this.props;
    console.log('🚀 ~ file: Category.js:123 ~ Category ~ componentDidMount ~ entities:', entities);
    const { listingAds = [] } = jioAds;
    const { showPlpExtendedBanner = false } = plpExtendedBannerData;
    const {
      priceRevealMetaInfo = {},
      isPriceReveal = false,
      categoryCode,
      freeTextSearch
    } = productsAdditionalInfo;
    const {
      search: { screenType = '', screenName = '' }
    } = luxeScreens;
    if (
      pathname &&
      (pathname.includes('/search') || pathname.includes('/find')) &&
      totalResults === 0
    ) {
      if (name === 'luxe') {
        gtmEventPush({
          event: 'zero_search_interaction',
          event_category: 'search interactions',
          event_action: 'zero search results',
          event_label: freeTextSearch,
          search_term: freeTextSearch,
          page_name: 'Search Screen/luxe',
          page_type: screenType,
          store_type: 'luxe'
        });
      }
    }
  
    const productWrapper = document.getElementById('products');
    if (productWrapper) {
      const coordinates = productWrapper.children[0].getBoundingClientRect();
      this.setState({ productsViewCoordinate: coordinates });
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const isDynamicWidget = urlParams.get('isDynamicWidget');
    const isCuratedWidget = urlParams.get('isCuratedWidget');
    const widgetLevel = urlParams.get('widgetLevel');
    const heading = urlParams.get('heading');
    const widgetName = urlParams.get('widgetName');
    const optionName = urlParams.get('optionName');
    const pageRedirected = urlParams.get('ref');
    const jioadredirect = pageRedirected === 'banner';
    const bannerName = localStorage.getItem('bannerName');
    const sourcePage = urlParams.get('sourcePage');
    const jioAdsSource = urlParams.get('jioAdsSource');
    const cId = localStorage.getItem('campaignId');
    let { plp: { pageType = '' } = {}, search = {} } = screen;
    const { location = {} } = window || {};
    let { pageType: fromPage = '' } = getPageInfo(location.href);
    const store = sis ? name : 'AJIO';
    if (store === 'luxe') fromPage = '';
    fromPage = `${fromPage} plp screen`;
    const priceRevealState = getPriceRevealSaleDuration(
      flags,
      'desktop',
      priceRevealMetaInfo,
      store
    );
    if (priceRevealState) {
      this.setState({ isPriceRevealState: true });
    }

    const isSearch = pathname?.includes('/search') || pathname?.includes('/find');
    if (isSearch) {
      fromPage = totalResults > 0 ? search.pageName : search.zeroSearchPageName;
    }
    const userId = decodeURIComponent(readCookie('U')) || '';
    if (signInCheck().length) {
      const data = JSON.parse(sessionStorage.getItem('customerTypeData')) || '';
      if (Object.keys(data).length === 0) {
        getLocaleData(userId, () => null);
      }
    }

    const searchedData = searchText || freeTextSearch;

    const plpSource = localStorage.getItem('search_plp_source_details') ? 'search' : fromPage;
    const plpSourceDetails = localStorage.getItem('search_plp_source_details') || fromPage;

    if (localStorage.getItem('search_used') === 'true' && !isSearch) {
      fromPage = 'search plp screen';
      localStorage.removeItem('search_used');
    }
    localStorage.removeItem('search_plp_source_details');

    let isDressTool=false;
    let dressToolSessionData;
    if(window?.location.search?.includes("dressTool")){
      isDressTool=true;
      let tempDressToolSessionData = sessionStorage.getItem('dressToolIngressDetails') || {};
      if(tempDressToolSessionData){
        dressToolSessionData = JSON.parse(tempDressToolSessionData);
      }
    }
    let itmSourceDetail = null;
    if (isCopilotReferrer()) {
      itmSourceDetail = 'ai_assistant_widget';
    }
    const previousSourceValue = pathname?.includes('/search') || isVertexCategoryEnabled ? `|${previousSource}` : '';
    const dataForGtm = {
      plp_source: jioadredirect ? 'jio ads' : isDressTool ? 'bra_dress tool' : sourcePage || plpSource,
      plp_source_details: itmSourceDetail
        ? itmSourceDetail :
        jioadredirect
          ? `jioads - ${bannerName} - ${cId}`
          : jioAdsSource
            ? jioAdsSource.replaceAll('[ccb]', Date.now())
            : isDressTool ? (dressToolSessionData && dressToolSessionData?.BannerName ? dressToolSessionData?.BannerName : plpSourceDetails) : plpSourceDetails,
      number_results: totalResults,
      plp_category_id: categoryCode,
      plp_store_type: store,
      zero_search_term: isSearch && totalResults === 0 ? searchTerm : '',
      store,
      plp_page_title: searchedData,
      bbs_widget: priceRevealState ? 'visible' : 'not visible',
      bbs_widget_title: priceRevealState
        ? getBBSWidgetTitleForGA(priceRevealState, flags, 'desktop', store, priceRevealMetaInfo)
        : '',
      bbs_widget_state:
        localStorage?.getItem('priceReveal_v2') || priceRevealState === 'DURING_SALE'
          ? 'sale price revealed'
          : 'sale price not revealed',
      user_personalization_bucket: clusterFeatureFlag ? readClusterCookie('cluster', name) : '',
      banner_theme_extended: showPlpExtendedBanner && !priceRevealState ? 'yes' : 'no',
      serviceName: 'plp',
      // jio_ads_enabled: jioAdsShowOnPageLoad(enableAdsOnPlpFlag, entities)
      // price_reveal_banner: priceRevealState ? 'visible' : 'not visible',
      type_of_redirection: `${getPLPTypeOfRedirection(pathname || '')} ${previousSourceValue}`,
      search_term: isSearch && searchTerm ? searchTerm : '',
      user_search_term: isSearch && searchTerm ? searchTerm : '',
      page_category: pageCategory
    };
    if(isDressTool){
      dataForGtm.dress_tool_ingress = (dressToolSessionData && dressToolSessionData?.IngressPoint ? dressToolSessionData?.IngressPoint : '');
    }

    // Check if the cms banner flag exists
    const cmsFlagBannerAds = sessionStorage.getItem('cmsFlagBannerAds');
    if (cmsFlagBannerAds) {
      dataForGtm.jio_ads_enabled =
        cmsFlagBannerAds === 'true' || (cmsFlagBannerAds === 'false' ? false : 'Not Set');
      sessionStorage.removeItem('cmsFlagBannerAds');
    }
    if (isDynamicWidget) {
      dataForGtm.plp_source = 'widget';
      dataForGtm.plp_source_details =
        widgetLevel.toLocaleLowerCase() === 'user' ? `user_level_${heading}` : `dynamic_${heading}`;
    }

    if (isCuratedWidget) {
      dataForGtm.plp_source = 'widget';
      dataForGtm.plp_source_details = `curated_widget_${widgetName}_${optionName}`;
    }

    gtmPagePush('', pageType, window.__ENV__, dataForGtm);
    updateClusterCookie(name, clusterFeatureFlag);
    if (isSearch) {
      updateSlpAdsCookie();
    } else {
      updatePlpAdsCookie();
    }
    this.handleDynamicRemarketingSetup();

    // early access banner
    if (checkEarlyAccessUser('', 'plp') && earlyAccessCategory) {
      let pageUrl = pageUrls.desktop.earlyAceess || '';
      let bannerRequestData = getCategoryBannerRequestData(pageUrl, 'plp', this.props);
      getBanners(bannerRequestData);
    }

    // NOTE: FOR RUNNING FUNCTIONS ON DIVS USING KEYBOARD NAVIGATION
    document.addEventListener('keydown', e => {
      if (e.code == 'Enter') {
        if (!(e.target?.tagName === 'A' && e.target?.hasAttribute('href'))) {
          document.activeElement.click();
        }
      }
    });

    window.addEventListener('load', () => {
      const srFocus = document.getElementById('sr-init-focus');
      if (srFocus) {
        srFocus.focus({ preventScroll: true });

        const skipLink = document.getElementById('skip-link');
        if (skipLink) {
          skipLink.focus({ preventScroll: true });
        }
      }
    });

    window.addEventListener('beforeunload', e => {
      localStorage.removeItem('isCouponPlp');
    });
  }

  componentDidUpdate() {
    const { productsAdditionalInfo = {}, entities, pathname, facets } = this.props;
    const { freeTextSearch } = productsAdditionalInfo;
    const { JioAds } = window;
    const isSearch = pathname?.includes('/search') || pathname?.includes('/find');
    if (JioAds && this.state.isJioAdsLoaded) {
      jioAdsProductListViewEvent(entities, facets);
      deeplinkLaunchEvent();
      if (isSearch) {
        jioAdsSearchViewEvent(entities, freeTextSearch);
      }
      this.setState({
        isJioAdsLoaded: false
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.updateFacetStyle);
    document.removeEventListener('keydown', () => {});
  }

  handleDynamicRemarketingSetup = () => {
    const { topResults = [], pathname } = this.props;
    if (topResults.length > 0) {
      const isSearch = pathname.includes('/search') || pathname.includes('/find');
      let pageType = isSearch ? 'searchresults' : 'category';
      gtmDynamicRemarketingSetup(topResults, pageType);
    }
  };

  elementInViewport(el, offsetTop = 0) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.top - offsetTop <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  _updateFacetStyle(event) {
    this.facetReference = this.facetReference
      ? this.facetReference
      : document.getElementById('facets');
    // this.facetReference.classList.add("translate-elm");
    let footer = document.getElementsByClassName('main-footer')[0];
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    let downWardScroll = true;
    if (this.lastScrollPosition) {
      downWardScroll = !(this.lastScrollPosition > scrollTop);
    }
    this.lastScrollPosition = scrollTop;
    // if(!downWardScroll){
    //   this.facetReference.classList.remove("translate-elm");
    // }

    if (this.elementInViewport(footer)) {
      this.facetReference.style.position = 'absolute';
      this.facetReference.style.top = `auto`;
      this.facetReference.style.bottom = 0;
    } else {
      this.facetReference.removeAttribute('style');
    }
  }

  render() {
    const {
      rilfnlBreadCrumb = [],
      flags,
      productsAdditionalInfo = {},
      totalResults = 0,
      pathname = '',
      metaData: { name = '', sis = false } = {},
      newDesignLuxe,
      httpError = {},
      plpExtendedBannerData = {},
      isSuggestStoreLink = false,
      earlyAccessCategory,
      plpBanners,
      earlyAccessFlag,
      searchText
    } = this.props;
    let { error: { errorType = '', message = '', statusCode = 404 } = {} } = httpError;

    const isSearch = pathname.includes('/search') || pathname.includes('/find');
    const {
      banners = [],
      showPlpExtendedBanner = false,
      extendedBannerCarouselTimer = 5
    } = plpExtendedBannerData;

    // fixedBtnProps = {fixedBtnProps}

    // DEAL OF THE DAY
    const {
      dealStartTime = '',
      dealEndTime = '',
      priceRevealMetaInfo = {}
    } = productsAdditionalInfo;
    const priceRevealState = getPriceRevealSaleDuration(
      flags,
      'desktop',
      priceRevealMetaInfo,
      name === '' ? 'AJIO' : name
    );
    const { isDealStart = false } = dealStartTime && IsDealStart(dealStartTime);
    const { isDealEnd = true } = dealEndTime && IsDealEnd(dealEndTime);
    const topTimerDod =
      isDealStart && !isDealEnd ? (
        <div className="dealOfDayTimer">
          <DealOfTheDayTimerTag
            dealOfTheDayProductTimer={dealEndTime}
            isStartIn
            topTimerOrProductTimer
            showModal={this.props.showModal}
            modalName="plp-dod-time-up"
          />
        </div>
      ) : (
        ''
      );
    let marginTop = 100;
    marginTop = isDealStart && !isDealEnd ? (marginTop += 50) : marginTop;

    const {
      offerEndTime = '',
      endTimerVisibility = false,
      timerStartBefore = ''
    } = productsAdditionalInfo;
    const currentTime = new Date().getTime();
    const isSignedIn = signInCheck();
    const isEarlyAccessUser = isSignedIn && earlyAccessFlag && checkEarlyAccessUser(name);
    return (
      <>
        <div id="sr-init-focus" tabindex="-1" style={{position:'absolute', left:`-9999px`, height:`1px`, width:`1px`, overflow:`hidden`}}></div>
        <a
          className="skip-link"
          tabIndex={0}
          onClick={() => {
            window.location.href = '#main-content';
            const mainContent = document.getElementById('main-content');
            mainContent.tabIndex = '-1';
            mainContent.focus();
          }}
        >
          Skip To Content
        </a>
        <Layout
          className={`${newDesignLuxe ? 'luxe-newdesign' : ''}`}
          noHeaderTitle
          footerSeo
          isFooter
          moveToTop
        >
          <ProductListContainer
            apiPath="/api/category"
            newDesignLuxe={newDesignLuxe}
            priceRevealState={priceRevealState}
          >
            {props => {
              const {
                searchInput,
                location,
                loadMoreItems,
                pushToHistory,
                isRequestOrginIsBrowser,
                hasErrored,
                errorDetails
              } = props;
              if (
                !isRequestOrginIsBrowser &&
                hasErrored &&
                errorDetails &&
                (errorDetails.status === 400 || errorDetails.status === 504)
              ) {
                return (
                  <div className="main-view-fluid">
                    <NotFound mobile={false} />
                  </div>
                );
              }
              if (
                !isRequestOrginIsBrowser &&
                hasErrored &&
                errorDetails &&
                errorDetails.status === 503
              ) {
                return (
                  <div className="error-page">
                    <Error503 name="plp" />
                  </div>
                );
              }
              return (
                <>
                  {endTimerVisibility ? (
                    <TimerStartBeforeComponent
                      topTimerOrProductTimer
                      endTime={offerEndTime}
                      timerStartBefore={timerStartBefore}
                      serverTime={currentTime}
                      pageType=""
                    />
                  ) : null}

                  {topTimerDod}
                  <Modal
                    name="plp-dod-time-up"
                    closeButton={false}
                    disableOutsideClick
                    className="dodModal"
                  >
                    <DealOfTheDayModal
                      alt="Timer icon"
                      logo="/static/img/timer.png"
                      header="Time is up"
                      timer
                      subText="Sorry, deal is over. Although you can buy this product on an updated price"
                      isStartIn={false}
                      topTimerOrProductTimer
                      redirect
                      modalName="plp-dod-time-up"
                    />
                  </Modal>
                  {newDesignLuxe &&
                    (isEarlyAccessUser && priceRevealState !== DURING_SALE ? (
                      <EarlyAccessBanner deviceType="desktop" luxe={newDesignLuxe} />
                    ) : (
                      <PriceRevealPLPBanner deviceType="desktop" luxe={newDesignLuxe} />
                    ))}
                  {showPlpExtendedBanner && totalResults !== 0 && !priceRevealState && (
                    <PlpExtendedBanner
                      banners={banners}
                      extendedBannerCarouselTimer={extendedBannerCarouselTimer}
                      isWeb
                    />
                  )}
                  {earlyAccessCategory && plpBanners.length > 0 && !priceRevealState && (
                    <PlpExtendedBanner banners={plpBanners} isWeb />
                  )}
                  <div
                    className={`${newDesignLuxe ? 'luxe-newdesign' : ''} ${isSuggestStoreLink &&
                      'suggestion-store-link'} main-view page page--category-desktop product-view`}
                    style={{ marginTop: !showPlpExtendedBanner ? `${marginTop}px` : '0px' }}
                  >
                    {Object.keys(httpError).length != 0 && errorType == 'info' && statusCode != 404 ? (
                      <div className={`err-msg-blk `}>
                        <ErrorMessage message={message} device="mobile" showCloseButton />
                      </div>
                    ) : (
                      ''
                    )}
                    {isSearch && totalResults == 0 ? (
                      <NoSearchResult
                        newDesignLuxe={newDesignLuxe}
                        isSuggestStoreLink={isSuggestStoreLink}
                      />
                    ) : (
                      <div>
                        {rilfnlBreadCrumb.length > 0 ? (
                          <BreadCrumb
                            breadcrumb={rilfnlBreadCrumb}
                            isPriceReveal={this.state.isPriceRevealState}
                          />
                        ) : null}

                        <div className="plp-view">
                          {newDesignLuxe ? <Info pushToHistory={pushToHistory} /> : ''}
                          <Loader name="quick-view-loader" />
                          <FacetFilterDesktopLeftPane
                            pushToHistory={pushToHistory}
                            rilfnlBreadCrumb={rilfnlBreadCrumb}
                          />
                          <div className="products" id="products">
                            {newDesignLuxe ? '' : <Info pushToHistory={pushToHistory} />}

                            {newDesignLuxe ? <NoResultPage pushToHistory={pushToHistory} /> : ''}

                            <AppliedFilter
                              pushToHistory={pushToHistory}
                              newDesignLuxe={newDesignLuxe}
                            />
                            <OfferInfoCartData />

                            <TopFiltersDesktop
                              pushToHistory={pushToHistory}
                              newDesignLuxe={newDesignLuxe}
                            />
                            <ProductGrid
                              searchInput={searchInput}
                              location={location}
                              loadMoreItems={loadMoreItems}
                              dimension={this.state.productsViewCoordinate}
                              pageType="plp"
                              showPlpExtendedBanner={showPlpExtendedBanner && !priceRevealState}
                            />
                          </div>

                          <FacetCheckboxModalContentDesktop
                            pushToHistory={pushToHistory}
                            newDesignLuxe={newDesignLuxe}
                          />
                          <FacetCategoryCheckboxModalContentDesktop
                            pushToHistory={pushToHistory}
                            newDesignLuxe={newDesignLuxe}
                          />
                          <ProductQuickview newDesignLuxe={newDesignLuxe} />
                        </div>
                      </div>
                    )}
                  </div>
                </>
              );
            }}
          </ProductListContainer>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = state => {
  const {
    productsAdditionalInfo = {},
    request = {},
    metaData = {},
    flags = {},
    httpError = {},
    grid: { results = [], entities = {} } = {},
    facets = {},
    jioAds = {}
  } = state;
  const { rilfnlBreadCrumbList = {}, isSuggestStoreLink = false } = productsAdditionalInfo;
  const { rilfnlBreadCrumb = [] } = rilfnlBreadCrumbList;
  const { totalResults, pathname, query = {} } = request;
  const { text: searchTerm = '', searchText = '' } = query;
  const clusterFeatureFlag = getClusterFeatureFlag(flags);
  const enableAdsOnPlpFlag = getEnableAdsOnPlp(state);
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const plpExtendedBannerData = getPlpExtendedBannerImages(state);
  const earlyAccessCategory = getEarlyAccessbannerFlagCategory(flags);
  const plpBanners = getPlpBanners(state);
  const earlyAccessFlag = getEarlyAccessFlag(flags);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const previousSource = getPreviousSearchSource(state);
  const pageCategory = getPageCategory(state);

  return {
    newDesignLuxe,
    rilfnlBreadCrumb,
    productsAdditionalInfo,
    totalResults,
    pathname,
    metaData,
    flags,
    searchTerm,
    clusterFeatureFlag,
    enableAdsOnPlpFlag,
    entities,
    httpError,
    plpExtendedBannerData,
    topResults: results.slice(0, 3),
    isSuggestStoreLink,
    earlyAccessCategory,
    plpBanners,
    earlyAccessFlag,
    searchText,
    jioAds,
    results,
    facets,
    previousSource,
    pageCategory,
    isVertexCategoryEnabled: getAmplitudeVariantPayload('enableCategoryWidgetsVertex', state, false) && getAmplitudeExperimentVariant('vertex-exp-flag',state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getLocaleData: (userId, callback) => {
      dispatch(getLocaleData(userId, callback));
    },
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    getBanners: obj => {
      dispatch(getRuntimeBanners(obj));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Category);
